import React, {PropTypes} from 'react';

const RecipeInfo = ({recipe, className, onClick}) => {
	let monthNames = ["January", "February", "March", "April", "May", "June",
		"July", "August", "September", "October", "November", "December"
	];			
	let pubDate = new Date(recipe.dateAdded);
	let pubMonth = monthNames[pubDate.getMonth()];
	let pubYear = pubDate.getFullYear();
	return(
		<div 
			className={className}
			onClick={onClick}
		>			
			<h2>{recipe.title}</h2>
			<h3>Chef: <span>{recipe.firstName} {recipe.lastName}</span></h3>
			<div className="recipe-details">Submitted: {pubMonth} {pubYear}</div>
			<div className="recipe-details">Prep Time: 25 min.</div>
			<div className="recipe-buttons">
				<div className="recipe-button rose">Reviews</div>
				<div className="recipe-button rose">Feedback</div>
			</div>
			<div className="recipe-purchase">
				<div className="recipe-price">Approximate Cost: $16.00</div>
				<div className="recipe-button gold">Buy Ingredients</div>
			</div>
		</div>
	);
};

RecipeInfo.propTypes = {
	recipe: PropTypes.object.isRequired,
	className: PropTypes.string,
	onClick: PropTypes.func
};

export default RecipeInfo;


/** WEBPACK FOOTER **
 ** ./src/components/recipes/RecipeInfo.js
 **/